import AntSkeleton, { SkeletonProps as AntSkeletonProps } from 'antd/lib/skeleton';

import styles from './styles.module.scss';
import { Fragment } from 'react';

interface NotificationsSkeletonProps extends AntSkeletonProps {
  rowCount?: number;
  pagination?: boolean;
}

export const NotificationsSkeleton = ({
  rowCount = 20,
  pagination = false,
}: NotificationsSkeletonProps) => (
  <div className={styles.main}>
    {!pagination && (
      <>
        <div className={styles.slider}>
          {[...Array(5)].map(() => (
            <AntSkeleton.Button
              active
              size="small"
              shape="round"
              block
              className={styles.sliderButton}
            />
          ))}
        </div>
        <div className={styles.actionButtons}>
          <AntSkeleton.Button
            active
            size="small"
            shape="round"
            block
            className={styles.actionButton}
          />
          <AntSkeleton.Avatar active shape={'circle'} size={40} />
        </div>
      </>
    )}
    {[...Array(rowCount)].map((_, index) => (
      <Fragment key={`notifications-skeleton-list-${index}`}>
        <div className={styles.row}>
          <AntSkeleton.Avatar active shape={'circle'} size={40} />
          <div>
            <AntSkeleton.Button active size="small" shape="round" block className={styles.field1} />
            <AntSkeleton.Button active size="small" shape="round" block className={styles.field2} />
          </div>
        </div>
      </Fragment>
    ))}
  </div>
);
